export default "__VITE_ASSET__06e11fb3__"